<script>
import Errors from './../../errors'

export default {
        components: {},
        props: {
            page: {
                required: false,
                type: String,
                default: null,
            },
            maileonTag: {
                required: false,
                type: String,
                default: null,
            },
            doiKey: {
                required: false,
                type: String,
                default: null,
            },
        },
        data: function () {
            return {
                isSending: false,
                isSend: false,
                isError: false,
                errors: new Errors(),
                form: {
                    first_name: null,
                    last_name: null,
                    email: null,
                    page: this.page,
                    maileon_tag: this.maileonTag,
                    doi_key: this.doiKey,
                    recaptchaKey: '',
                },
                recaptchaLoaded: false,
            }
        },
        methods: {
            async subscribeNewsletter() {
                this.isSending = true;

                let vue = this;
                vue.form.recaptcha = await grecaptcha.execute('6Lfh5VEcAAAAAEXBTNqkfvMj3GvAFhRU1IZiAYZp', {
                    action: 'newsletterform'
                });

                axios.post(`/api/subscribe/newsletter/`, vue.form)
                .then(response => {
                    if (response.data.success === true) {
                        this.isSend = true;
                        this.isSending = false;

                        window.dataLayer.push({
                            'event': 'sign_up',
                            'method': 'Newsletter'
                        });
                    } else {
                        this.isSend = false;
                    }
                })
                .catch(error => {
                    this.errors.record(error.response.data.errors);
                    this.isSending = false;
                })
            },
            setRecaptchaKey() {
                //recaptcha
                if(!this.recaptchaLoaded){
                    let head = document.getElementsByTagName('head')[0];
                    let script = document.createElement('script');
                    script.type = 'text/javascript';

                    let src = "https://www.google.com/recaptcha/api.js?render=6Lfh5VEcAAAAAEXBTNqkfvMj3GvAFhRU1IZiAYZp";

                    const recaptchaAlreadyLoaded = document.querySelector(
                        `head script[src="${src}"]`
                    );

                    if(!recaptchaAlreadyLoaded) {
                        script.src = src;
                        head.appendChild(script);
                    }

                    this.recaptchaLoaded = true;
                }
            }
        },
        computed: {},
        watch: {},
        mounted() {
            this.setRecaptchaKey();
        },
        created() {}
    }
</script>
